import { ChangeEvent, KeyboardEvent, useState } from "react";

// material-ui
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";

// third-party
import { sub } from "date-fns";
import { Chance } from "chance";

// project imports
import { openSnackbar } from "store/slices/snackbar";
import SubCard from "ui-component/cards/SubCard";
import { useDispatch, useSelector } from "store";
import { addItem } from "store/slices/kanban";

// assets
import CalendarTodayTwoToneIcon from "@mui/icons-material/CalendarTodayTwoTone";
import PeopleAltTwoToneIcon from "@mui/icons-material/PeopleAltTwoTone";
import CloseIcon from "@mui/icons-material/Close";

// types
import { KanbanItem } from "types/kanban";

interface Props {
  columnId: string;
}

const chance = new Chance();

// ==============================|| KANBAN BOARD - ADD ITEM ||============================== //

const AddItem = ({ columnId }: Props) => {
  const dispatch = useDispatch();

  const [addTaskBox, setAddTaskBox] = useState(false);

  let columns = [
    {
      id: "column-1",
      title: "New",
      itemIds: ["3542", "8903", "1381"],
    },
    {
      id: "column-2",
      title: "Active",
      itemIds: ["6739", "3950", "6924"],
    },
    {
      id: "column-3",
      title: "Resolved",
      itemIds: ["4398"],
    },
    {
      id: "column-4",
      title: "Closed",
      itemIds: ["9589", "3410", "8679"],
    },
  ];

  let userStory = [
    {
      acceptance: "",
      assign: "profile-2",
      columnId: "column-4",
      commentIds: ["comment-5"],
      description:
        "Wo gegew jubva wiej pisniidi ic jarge mide ho ufcakub culuw ambupan te fezop rikic ekbet sevzog.",
      dueDate: "Mon Feb 27 2023 15:18:32 GMT+0530 (India Standard Time)",
      id: "2647",
      priority: "low",
      title: "School Management Backend",
      itemIds: ["3542", "8903", "1381"],
    },
    {
      acceptance:
        "Gid gimija ufuebjop vuji ze ir wi jih aruvihdok keubagob aguhogug uge tabu cure.",
      assign: "profile-3",
      columnId: "column-1",
      commentIds: ["comment-3"],
      description:
        "Onekane urwa joduzzij la cipebo zafuw atawa labfi hilza inepehhow inujufise hum.",
      dueDate: "Thu Feb 23 2023 15:13:31 GMT+0530 (India Standard Time)",
      id: "7833",
      priority: "high",
      title: "Inventory Implementation & Design",
      itemIds: ["4398", "3410"],
    },
    {
      acceptance:
        "Kiz ovmen fup jazaj rozibco fecki rasizsed pake redufkav joczatufo.",
      assign: "profile-3",
      columnId: "column-4",
      commentIds: ["comment-3", "comment-4"],
      description:
        "Lum vofdip keci fid fos di fikga kiinte izugfi gihude tewsadez ha niprizbef catin adahup.",
      dueDate: "Wed Feb 15 2023 10:30:11 GMT+0530 (India Standard Time)",
      id: "6940",
      priority: "medium",
      title: "Theme migration from v4 to v5",
      itemIds: ["6739", "9589", "8679"],
    },
    {
      acceptance: "Itorinceg cokmu ku pahkaavo argut.",
      assign: "profile-1",
      columnId: "column-3",
      commentIds: ["comment-4"],
      description:
        "Nar noljaw hi fusurri haodabi ewaw uc moetucu hilzirzo ca nidzerog ziw.",
      dueDate: "Tue Feb 07 2023 15:17:40 GMT+0530 (India Standard Time)",
      id: "4656",
      priority: "low",
      title: "Lunch Beauty Application",
      itemIds: ["3950", "6924"],
    },
  ];

 let items: KanbanItem[] = [
   {
     assign: "profile-1",
     attachments: [],
     commentIds: ["comment-1"],
     description: "Content of item 1",
     dueDate: "Fri Feb 03 2023 15:20:14 GMT+0530 (India Standard Time)",
     id: "3542",
     image: "profile-back-1.png",
     priority: "low",
     title: "Online fees payment & instant announcements",
   },
   {
     assign: "profile-2",
     attachments: [],
     commentIds: ["comment-2", "comment-5"],
     description: "Content of item 2",
     dueDate: "Sat Jan 28 2023 15:23:25 GMT+0530 (India Standard Time)",
     id: "4398",
     image: false,
     priority: "high",
     title: "Creation and Maintenance of Inventory Objects",
   },
   {
     assign: "profile-3",
     attachments: [],
     description: "Content of item 3",
     dueDate: "Tue Feb 07 2023 15:24:38 GMT+0530 (India Standard Time)",
     id: "6739",
     image: false,
     priority: "low",
     title: "Update React & TypeScript version",
   },
   {
     assign: "profile-2",
     attachments: [],
     commentIds: ["comment-4"],
     description: "Content of item 4",
     dueDate: "Thu Feb 09 2023 15:25:46 GMT+0530 (India Standard Time)",
     id: "3950",
     image: "profile-back-2.png",
     priority: "low",
     title: "Set allowing rules for trusted applications.",
   },
   {
     assign: "profile-2",
     attachments: [],
     commentIds: ["comment-1", "comment-2", "comment-5"],
     description: "Content of item 5",
     dueDate: "Mon Feb 06 2023 15:26:53 GMT+0530 (India Standard Time)",
     id: "6924",
     image: "profile-back-3.png",
     priority: "medium",
     title: "Managing Applications Launch Control",
   },
   {
     assign: "profile-3",
     attachments: [],
     commentIds: ["comment-3", "comment-4"],
     description: "Content of item 6",
     dueDate: "Wed Feb 15 2023 10:30:37 GMT+0530 (India Standard Time)",
     id: "9589",
     image: false,
     priority: "medium",
     title: "Run codemods",
   },
   {
     assign: "profile-1",
     attachments: [],
     description: "Content of item 7",
     dueDate: "Mon Feb 20 2023 15:29:58 GMT+0530 (India Standard Time)",
     id: "3410",
     image: "profile-back-4.png",
     priority: "low",
     title: "Purchase Requisitions, Adjustments, and Transfers.",
   },
   {
     assign: "profile-1",
     attachments: [],
     description: "Content of item 8",
     dueDate: "Sat Mar 04 2023 15:31:05 GMT+0530 (India Standard Time)",
     id: "8903",
     image: false,
     priority: "low",
     title: "Attendance checking & homework details",
   },
   {
     assign: "profile-3",
     attachments: [],
     commentIds: ["comment-3"],
     description: "Content of item 9",
     dueDate: "Thu Feb 23 2023 15:32:13 GMT+0530 (India Standard Time)",
     id: "1381",
     image: false,
     priority: "high",
     title: "Admission, Staff & Schedule management",
   },
   {
     assign: "profile-2",
     attachments: [],
     commentIds: ["comment-5"],
     description: "Content of item 10",
     dueDate: "Mon Feb 27 2023 15:33:04 GMT+0530 (India Standard Time)",
     id: "8679",
     image: false,
     priority: "low",
     title: "Handling breaking changes",
   },
 ];

  // const { columns, items, userStory } = useSelector((state) => state.kanban);
  const handleAddTaskChange = () => {
    setAddTaskBox((prev) => !prev);
  };

  const [title, setTitle] = useState("");
  const [isTitle, setIsTitle] = useState(false);

  const handleAddTask = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter" || event.keyCode === 13) {
      addTask();
    }
  };

  const addTask = () => {
    if (title.length > 0) {
      const newItem: KanbanItem = {
        id: `${chance.integer({ min: 1000, max: 9999 })}`,
        title,
        dueDate: sub(new Date(), { days: 0, hours: 1, minutes: 45 }),
        image: false,
        assign: "",
        description: "",
        priority: "low",
        attachments: [],
      };

      dispatch(addItem(columnId, columns, newItem, items, "0", userStory));
      dispatch(
        openSnackbar({
          open: true,
          message: "Task Add successfully",
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "alert",
          alert: {
            color: "success",
          },
          close: false,
        })
      );
      handleAddTaskChange();
      setTitle("");
    } else {
      setIsTitle(true);
    }
  };

  const handleTaskTitle = (event: ChangeEvent<HTMLInputElement>) => {
    const newTitle = event.target.value;
    setTitle(newTitle);
    if (newTitle.length <= 0) {
      setIsTitle(true);
    } else {
      setIsTitle(false);
    }
  };

  return (
    <Grid container alignItems="center" spacing={1} sx={{ marginTop: 1 }}>
      {addTaskBox && (
        <Grid item xs={12}>
          <SubCard
            contentSX={{ p: 2, transition: "background-color 0.25s ease-out" }}
          >
            <Grid container alignItems="center" spacing={0.5}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  placeholder="Add Task"
                  value={title}
                  onChange={handleTaskTitle}
                  sx={{
                    mb: 2,
                    "& input": {
                      bgcolor: "transparent",
                      p: 0,
                      borderRadius: "0px",
                    },
                    "& fieldset": { display: "none" },
                    "& .MuiFormHelperText-root": {
                      ml: 0,
                    },
                    "& .MuiOutlinedInput-root": {
                      bgcolor: "transparent",
                    },
                  }}
                  onKeyUp={handleAddTask}
                  helperText={isTitle ? "Task title is required." : ""}
                  error={isTitle}
                />
              </Grid>
              <Grid item>
                <Button
                  variant="text"
                  size="small"
                  color="primary"
                  sx={{ p: 0.5, minWidth: 32 }}
                  aria-label="people"
                >
                  <PeopleAltTwoToneIcon fontSize="small" />
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="text"
                  size="small"
                  color="primary"
                  sx={{ p: 0.5, minWidth: 32 }}
                  aria-label="calendar"
                >
                  <CalendarTodayTwoToneIcon fontSize="small" />
                </Button>
              </Grid>
              <Grid item xs zeroMinWidth />
              <Grid item>
                <Stack direction="row" alignItems="center" spacing={0.5}>
                  <IconButton
                    size="small"
                    color="error"
                    onClick={handleAddTaskChange}
                    aria-label="cancel add task"
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={addTask}
                    size="small"
                  >
                    Add
                  </Button>
                </Stack>
              </Grid>
            </Grid>
          </SubCard>
        </Grid>
      )}
      {!addTaskBox && (
        <Grid item xs={12}>
          <Button
            variant="text"
            color="primary"
            sx={{ width: "100%" }}
            onClick={handleAddTaskChange}
          >
            Add Task
          </Button>
        </Grid>
      )}
    </Grid>
  );
};

export default AddItem;
